var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurguerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8813 44.9992H53.1312C54.167 44.9992 55.0062 45.8387 55.0062 46.8742C55.0062 47.8235 54.3009 48.608 53.3857 48.732L53.1312 48.7492H6.8813C5.84575 48.7492 5.0063 47.9097 5.0063 46.8742C5.0063 45.925 5.71168 45.1405 6.62688 45.0162L6.8813 44.9992H53.1312H6.8813ZM6.8813 28.7567H53.1312C54.167 28.7567 55.0062 29.5962 55.0062 30.6317C55.0062 31.581 54.3009 32.3655 53.3857 32.4897L53.1312 32.5067H6.8813C5.84575 32.5067 5.0063 31.6672 5.0063 30.6317C5.0063 29.6825 5.71168 28.898 6.62688 28.7737L6.8813 28.7567H53.1312H6.8813ZM6.87915 12.5073H53.1292C54.1647 12.5073 55.0042 13.3468 55.0042 14.3823C55.0042 15.3316 54.2987 16.116 53.3837 16.2402L53.1292 16.2573H6.87915C5.8436 16.2573 5.00415 15.4178 5.00415 14.3823C5.00415 13.4331 5.70953 12.6486 6.62473 12.5244L6.87915 12.5073H53.1292H6.87915Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurguerMenu);
export default __webpack_public_path__ + "static/media/burguerMenu.307cb08dbe191966d1ace8e5e51f72c3.svg";
export { ForwardRef as ReactComponent };